// StaffSetUpValidation.js

export const validateStaffSetUp = (formData) => {
  const errors = {};

  // Roll Id validation
  if (!formData.rollId || formData.rollId.trim() === "") {
    errors.rollId = "Roll ID is required";
  }

  // First Name validation
  if (!formData.firstName || formData.firstName.trim() === "") {
    errors.firstName = "First Name is required";
  } else if (formData.firstName.length < 2) {
    errors.firstName = "First Name must be at least 2 characters";
  } else if (!/^[a-zA-Z\s]+$/.test(formData.firstName)) {
    errors.firstName = "First Name should contain only letters";
  }

  // Last Name validation
  if (!formData.lastName || formData.lastName.trim() === "") {
    errors.lastName = "Last Name is required";
  }
  // else if (formData.lastName.length < 2) {
  //   errors.lastName = "Last Name must be at least 2 characters";
  // }
  else if (!/^[a-zA-Z\s]+$/.test(formData.lastName)) {
    errors.lastName = "Last Name should contain only letters";
  }

  // Email validation
  if (!formData.emailAddress || formData.emailAddress.trim() === "") {
    errors.emailAddress = "Email Address is required";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emailAddress)) {
    errors.emailAddress = "Please enter a valid email address";
  }

  // Mobile Number validation
  if (!formData.mobileNumber || formData.mobileNumber.trim() === "") {
    errors.mobileNumber = "Mobile Number is required";
  } else if (!/^[0-9]{10}$/.test(formData.mobileNumber)) {
    errors.mobileNumber = "Mobile Number must be 10 digits";
  }

  // Staff Type validation
  if (!formData.staffType || formData.staffType === "") {
    errors.staffType = "Staff Type is required";
  }

  // Teaching Course validation
  if (
    formData.staffType === "TEACHING" &&
    (!formData.teachingCourse || formData.teachingCourse.length === 0)
  ) {
    errors.teachingCourse = "Teaching Course is required";
  }

  // Date of Joining validation
  if (!formData.dateOfJoining || formData.dateOfJoining === "") {
    errors.dateOfJoining = "Date of Joining is required";
  }

  // Gender validation
  if (!formData.gender || formData.gender === "") {
    errors.gender = "Gender is required";
  }

  // Blood Group validation
  if (!formData.bloodGroup || formData.bloodGroup === "") {
    errors.bloodGroup = "Blood Group is required";
  }

  // Date of Birth validation
  if (!formData.dateOfBirth || formData.dateOfBirth === "") {
    errors.dateOfBirth = "Date of Birth is required";
  } else {
    const dob = new Date(formData.dateOfBirth);
    const today = new Date();
    const age = today.getFullYear() - dob.getFullYear();
    if (age < 18) {
      errors.dateOfBirth = "Staff must be at least 18 years old";
    }
  }

  // PAN Number validation
  if (formData.panNumber && formData.panNumber.trim() !== "") {
    if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(formData.panNumber.toUpperCase())) {
      errors.panNumber = "Please enter a valid PAN Number (e.g., ABCDE1234F)";
    }
  }

  // Aadhar Number validation
  if (!formData.aadharNumber || formData.aadharNumber.trim() === "") {
    errors.aadharNumber = "Aadhar Number is required";
  } else if (!/^[0-9]{12}$/.test(formData.aadharNumber)) {
    errors.aadharNumber = "Aadhar Number must be 12 digits";
  }

  // Marital Status validation
  if (!formData.maritalStatus || formData.maritalStatus === "") {
    errors.maritalStatus = "Marital Status is required";
  }

  // Address 1 validation
  if (!formData.address1 || formData.address1.trim() === "") {
    errors.address1 = "Address is required";
  }

  // Pincode validation
  if (!formData.pincode || formData.pincode.trim() === "") {
    errors.pincode = "Pincode is required";
  } else if (!/^[0-9]{6}$/.test(formData.pincode)) {
    errors.pincode = "Pincode must be 6 digits";
  }

  // City validation
  if (!formData.city || formData.city.trim() === "") {
    errors.city = "City is required";
  }

  // State validation
  if (!formData.state || formData.state === "") {
    errors.state = "State is required";
  }

  // Country validation
  if (!formData.country || formData.country === "") {
    errors.country = "Country is required";
  }

  // Emergency Contact validation (optional but if provided, validate)
  if (formData.emergencyContact && formData.emergencyContact !== "") {
    if (!/^[0-9]{10}$/.test(formData.emergencyContact)) {
      errors.emergencyContact = "Emergency Contact must be 10 digits";
    }
  }

  return errors;
};

export const validateField = (name, value, formData = {}) => {
  let error = "";

  switch (name) {
    case "rollId":
      if (!value || value.trim() === "") {
        error = "Roll ID is required";
      }
      break;

    case "firstName":
      if (!value || value.trim() === "") {
        error = "First Name is required";
      } else if (value.length < 2) {
        error = "First Name must be at least 2 characters";
      } else if (!/^[a-zA-Z\s]+$/.test(value)) {
        error = "First Name should contain only letters";
      }
      break;

    case "middleName":
      if (value && !/^[a-zA-Z\s]*$/.test(value)) {
        error = "Middle Name should contain only letters";
      }
      break;

    case "lastName":
      if (!value || value.trim() === "") {
        error = "Last Name is required";
      }
      //   else if (value.length < 2) {
      //     error = "Last Name must be at least 2 characters";
      //   }
      else if (!/^[a-zA-Z\s]+$/.test(value)) {
        error = "Last Name should contain only letters";
      }
      break;

    case "emailAddress":
      if (!value || value.trim() === "") {
        error = "Email Address is required";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        error = "Please enter a valid email address";
      }
      break;

    case "mobileNumber":
      if (!value || value.trim() === "") {
        error = "Mobile Number is required";
      } else if (!/^[0-9]{10}$/.test(value)) {
        error = "Mobile Number must be 10 digits";
      }
      break;

    case "phoneNumber":
      if (value && !/^[0-9]{10,12}$/.test(value)) {
        error = "Please enter a valid phone number";
      }
      break;

    case "staffType":
      if (!value || value === "") {
        error = "Staff Type is required";
      }
      break;

    case "teachingCourse":
      if (!value || (Array.isArray(value) && value.length === 0)) {
        error = "Teaching Course is required";
      }
      break;

    case "dateOfJoining":
      if (!value || value === "") {
        error = "Date of Joining is required";
      }
      break;

    case "gender":
      if (!value || value === "") {
        error = "Gender is required";
      }
      break;

    case "bloodGroup":
      if (!value || value === "") {
        error = "Blood Group is required";
      }
      break;

    case "dateOfBirth":
      if (!value || value === "") {
        error = "Date of Birth is required";
      } else {
        const dob = new Date(value);
        const today = new Date();
        const age = today.getFullYear() - dob.getFullYear();
        if (age < 18) {
          error = "Staff must be at least 18 years old";
        }
      }
      break;

    case "panNumber":
      if (value && value.trim() !== "") {
        if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value.toUpperCase())) {
          error = "Please enter a valid PAN Number (e.g., ABCDE1234F)";
        }
      }
      break;

    case "aadharNumber":
      if (!value || value.trim() === "") {
        error = "Aadhar Number is required";
      } else if (!/^[0-9]{12}$/.test(value)) {
        error = "Aadhar Number must be 12 digits";
      }
      break;

    case "maritalStatus":
      if (!value || value === "") {
        error = "Marital Status is required";
      }
      break;

    case "address1":
      if (!value || value.trim() === "") {
        error = "Address is required";
      }
      break;

    case "pincode":
      if (!value || value.trim() === "") {
        error = "Pincode is required";
      } else if (!/^[0-9]{6}$/.test(value)) {
        error = "Pincode must be 6 digits";
      }
      break;

    case "city":
      if (!value || value.trim() === "") {
        error = "City is required";
      }
      break;

    case "state":
      if (!value || value === "") {
        error = "State is required";
      }
      break;

    case "country":
      if (!value || value === "") {
        error = "Country is required";
      }
      break;

    case "emergencyContact":
      if (value && value.trim() !== "") {
        if (!/^[0-9]{10}$/.test(value)) {
          error = "Emergency Contact must be 10 digits";
        }
      }
      break;

    default:
      break;
  }

  return error;
};
